import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Sidebar } from '../components/dashboard/Sidebar';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
import { DashboardHome } from '../components/dashboard/DashboardHome';
import { CandidatesList } from '../components/dashboard/CandidatesList';
import { CandidateDetail } from '../components/dashboard/CandidateDetail';
import { CandidateComparison } from '../components/dashboard/CandidateComparison';
import { ScreeningScheduler } from '../components/dashboard/ScreeningScheduler';
import { AnalyticsDashboard } from '../components/dashboard/AnalyticsDashboard';
import { AIRecruiters } from '../components/dashboard/AIRecruiters';
import { SettingsPage } from '../components/dashboard/SettingsPage';
import { CommunicationCentral } from '../components/dashboard/CommunicationCentral';
export const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  return <div className="flex h-screen bg-gray-100" data-id="element-2137">
      <Sidebar isOpen={sidebarOpen} data-id="element-2138" />
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2139">
        <DashboardHeader onMenuToggle={() => setSidebarOpen(!sidebarOpen)} isSidebarOpen={sidebarOpen} data-id="element-2140" />
        <main className="flex-1 overflow-y-auto bg-gray-50 p-4" data-id="element-2141">
          <Routes data-id="element-2142">
            <Route path="/" element={<DashboardHome data-id="element-2144" />} data-id="element-2143" />
            <Route path="/candidates" element={<CandidatesList data-id="element-2146" />} data-id="element-2145" />
            <Route path="/candidates/:id" element={<CandidateDetail data-id="element-2148" />} data-id="element-2147" />
            <Route path="/compare" element={<CandidateComparison data-id="element-2150" />} data-id="element-2149" />
            <Route path="/schedule" element={<ScreeningScheduler data-id="element-2152" />} data-id="element-2151" />
            <Route path="/analytics" element={<AnalyticsDashboard data-id="element-2154" />} data-id="element-2153" />
            <Route path="/ai-recruiters" element={<AIRecruiters data-id="element-2156" />} data-id="element-2155" />
            <Route path="/settings" element={<SettingsPage data-id="element-2158" />} data-id="element-2157" />
            <Route path="/communication" element={<CommunicationCentral data-id="element-2160" />} data-id="element-2159" />
          </Routes>
        </main>
      </div>
    </div>;
};